import React, { useState } from 'react';
import { useScrollDetection } from '../hooks/useScrollDetection';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeLink, setActiveLink] = useState('home');
    const isScrolled = useScrollDetection(50);

    const menuItems = [
        { label: "Home", id: "home" },
        { label: "Why Infinity", id: "whyinfinity" },
        { label: "About Us", id: "aboutus" },
        { label: "Problem - Solution", id: "problem-solution" },
        { label: "Contact Us", id: "contactus" }
    ];

    const handleMenuToggle = () => setIsMenuOpen(!isMenuOpen);

    const handleNavClick = (item, sectionId) => {
        setActiveLink(sectionId);
        setIsMenuOpen(false);
        if (item === "Home") window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleKeyDown = (e, item, sectionId) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleNavClick(item, sectionId);
        }
    };

    return (
  <header
    className={`fixed top-0 left-0 right-0 z-50 w-full px-6 md:px-[7.5rem]
    font-funnel scroll-smooth transition-all duration-500 ease-in-out
    ${
      isScrolled
        ? 'bg-black/30 backdrop-blur-[19px] shadow-md pt-4 pb-3 sm:pt-6 sm:pb-4 md:pt-8 md:pb-4 lg:pt-6 lg:pb-5'
        : 'bg-transparent pt-[2.4rem] pb-4 sm:pt-10 sm:pb-5 md:pt-12 md:pb-6 lg:pt-14 lg:pb-8'
    }
    text-white`}
  role="banner"
>
  <div className="mx-auto w-full max-w-[93rem] flex flex-col lg:flex-row lg:items-center lg:justify-between">
    
    {/* Logo Section */}
    <div className="flex justify-between items-center w-full lg:w-auto">
      <a
        href="/"
        aria-label="Platypus - Home"
        className="focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded"
      >
        <img
          src="/Vector.png"
          alt="Platypus Logo"
          className="w-[120px] sm:w-[160px] lg:w-[180px] xl:w-[230px] h-auto transition-all duration-500"
        />
      </a>

      {/* Mobile menu toggle */}
      <button
        onClick={handleMenuToggle}
        className="lg:hidden relative w-8 h-8 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded"
        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isMenuOpen}
        aria-controls="mobile-menu"
      >
        <div
          className={`flex flex-col justify-center items-center w-6 h-6 transition-all duration-300 ${
            isMenuOpen ? 'rotate-45' : ''
          }`}
        >
          <span
            className={`block h-0.5 w-6 bg-white transform transition-all duration-300 ${
              isMenuOpen ? 'rotate-90 translate-y-0' : '-translate-y-2'
            }`}
          ></span>
          <span
            className={`block h-0.5 w-6 bg-white transition-all duration-300 ${
              isMenuOpen ? 'opacity-0' : 'opacity-100'
            }`}
          ></span>
          <span
            className={`block h-0.5 w-6 bg-white transform transition-all duration-300 ${
              isMenuOpen ? '-rotate-90 -translate-y-0' : 'translate-y-2'
            }`}
          ></span>
        </div>
      </button>
    </div>

    {/* Desktop Menu Section */}
    <nav
      className="hidden lg:flex items-center justify-center w-full mt-4 lg:mt-0"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="p-[1.4px] rounded-[12px] bg-gradient-to-r from-[#77670B] via-[#FFE135] to-[#DDF1B1]">
        <div className="bg-black rounded-[12px] px-4 xl:px-8 py-3 xl:py-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-[11px] sm:text-[13px] lg:text-[14px] xl:text-[16px]">
          {menuItems.map((item, index) => {
            const isActive = activeLink === item.id;
            return (
              <a
                key={index}
                href={`#${item.id}`}
                onClick={() => handleNavClick(item.label, item.id)}
                onKeyDown={(e) => handleKeyDown(e, item.label, item.id)}
                className={`transition-colors duration-300 hover:text-yellow-400 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded px-2 py-1 ${
                  isActive ? 'text-yellow-400 font-semibold' : 'text-white'
                }`}
                aria-current={isActive ? 'page' : undefined}
              >
                {item.label}
              </a>
            );
          })}
        </div>
      </div>
        {/* Social Icons */}
        {/*<div className="p-[1.4px] rounded-[12px] bg-gradient-to-r from-[#77670B] via-[#FFE135] to-[#DDF1B1] lg:mr-[60px]">
            <div className="flex items-center rounded-[12px] px-5 py-[1.4rem] xl:py-[1.4rem] bg-black gap-4">
                <a href="https://www.facebook.com/share/1TdjBby6kM/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-yellow-300 transition duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded">
                    <img src="/fb.png" alt="" className="h-4 w-2 macbook:w-[3.5rem]" role="presentation" />
                </a>
                <a href="https://www.instagram.com/platypus_bth" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-yellow-300 transition duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded">
                    <img src="/instagram.png" alt="" className="h-4 w-4 macbook:w-[3.5rem]" role="presentation" />
                </a>
            </div>
        </div>*/}
    </nav>
  </div>

  {/* Mobile menu */}
  {isMenuOpen && (
    <>
      <div
        className="fixed inset-0 bg-black z-[100] lg:hidden"
        onClick={() => setIsMenuOpen(false)}
        aria-hidden="true"
      />
      <nav
        id="mobile-menu"
        className="fixed top-0 right-0 h-screen w-80 lg:hidden z-[101] transform transition-all duration-500 ease-in-out bg-black border-l-2 border-yellow-400/50 p-6"
        role="navigation"
        aria-label="Mobile navigation"
      >
        <ul className="flex flex-col gap-4">
          {menuItems.map((item, index) => {
            const isActive = activeLink === item.id;
            return (
              <li key={index}>
                <a
                  href={`#${item.id}`}
                  onClick={() => handleNavClick(item.label, item.id)}
                  onKeyDown={(e) => handleKeyDown(e, item.label, item.id)}
                  className={`block w-full text-left transition-colors duration-300 hover:text-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400 rounded px-2 py-2 ${
                    isActive ? 'text-yellow-400 font-semibold' : 'text-white'
                  }`}
                  aria-current={isActive ? 'page' : undefined}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  )}
</header>

    );
};

export default Navbar;
